import { storageService } from './storage';

export function esCapacidadFull(codigo: string): boolean {
  const capacidades = storageService.getSuscripcion()?.capacidades;
  if (!capacidades) return true;
  return capacidades[codigo] !== 'preview';
}

export function obtenerEtiquetaAccionPlan(): string {
  return storageService.getSuscripcion()?.activo === false ? 'Renovar' : 'Actualizar plan';
}
